import { useEffect, useState } from 'react';

import { BackHeader, PageTemplate } from '@_widgets/common';

import { notificationApi, notificationModel } from '@_entities/user';

import { get } from '@_shared/config';
import { CHARACTER_IMGS } from '@_shared/imgs';
import { SkeletonUI } from '@_shared/ui';
import { Pagination } from '@_shared/ui/Pagination';
import { Typography } from '@_shared/ui/Typography';

import * as S from './NotificationPage.style';

export function NotificationPage() {
	const [data, setData] = useState<notificationModel.TNotificationsResponse>();

	useEffect(() => {
		notificationApi.getNotificationList().then(({ data: responseData }) => {
			setData(responseData);
		});
	}, []);

	return (
		<PageTemplate header={<BackHeader>알림</BackHeader>} nav={false}>
			{/* Skeleton UI */}
			{data === undefined ? (
				<S.NotificationList>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
					<S.NotificationItem isRead>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="60px" height="24px" borderRadius="8px" />
					</S.NotificationItem>
				</S.NotificationList>
			) : (
				<>
					{/* Notification Data 가 있을때 */}
					{data?.results.length > 0 ? (
						<Pagination
							onPaginate={() => {
								if (data.next && data.next !== 'None') {
									// Pagination
									get<notificationModel.TNotificationsResponse>(data.next).then(
										({ data: responseData }) => {
											setData(() => ({
												next: responseData.next,
												previous: '',
												results: [...data.results, ...responseData.results],
											}));
										},
									);
								}
							}}
						>
							<S.NotificationList>
								{data.results.map((notification) => (
									<S.NotificationItem
										isRead={notification.isRead}
										key={`${notification.id}notification`}
										onClick={() => {
											window.location.href = notification.redirectURL;
										}}
									>
										<Typography type="title-medium" color="brown-primary">
											{notification.content}
										</Typography>
										<Typography type="label-large" color="font-tertiary">
											{notification.createdAgo}
										</Typography>
									</S.NotificationItem>
								))}
								<S.NotificationAlert>
									<Typography
										type="title-small"
										color="warmgray-500"
										textAlign="center"
									>
										최근 30일 이내의 알림만 확인할 수 있어요.
									</Typography>
								</S.NotificationAlert>
							</S.NotificationList>
						</Pagination>
					) : (
						<S.NoData>
							{/* Notification Data 가 없을때 */}
							<img
								src={CHARACTER_IMGS.READING_CHARACTER_IMG}
								alt="reading_character"
							/>
							<Typography type="title-large" color="warmgray-600">
								최근 받은 알림이 없어요
							</Typography>
						</S.NoData>
					)}
				</>
			)}
		</PageTemplate>
	);
}
